module.exports = __webpack_public_path__ + "img/delete.5f07e731.png";